// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import EventListResultModel from '../../model/event-list-result-model';
import EventListResultDTO from '../dto/event-list-result-dto';
import dtoSchema from '../schemas/event-list-result-schema';
import EventModel from '../../model/event-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class EventListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<EventListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => EventModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: EventModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<EventListResultDTO>): EventListResultModel;
  static toModel(dto: DeepPartial<EventListResultDTO> | undefined | null): EventListResultModel | undefined;
  static toModel(dto: DeepPartial<EventListResultDTO> | undefined | null): EventListResultModel | undefined {
    return dto ? new EventListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<EventListResultModel> | EventListResultModel): EventListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as EventListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for EventListResultModel, can not map to EventListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
